import { $_app_server } from '@/_helpers'

export const gsuService = {
    listOrdinances,
    docStatuses, 
    stat
}

function listOrdinances (from, to) {
  return  $_app_server.get("gsu/sessiondocs?from="+from+"&to="+to)
  .then(response => response.data)
}

function docStatuses () {
  return $_app_server.get("gsu/docstatuses").then(response => response.data)
}

function stat (from, to) {
  return  $_app_server.get("gsu/stat?from="+from+"&to="+to)
  .then(response => response.data)
}
  